import 'purecss/build/pure.css'
import 'purecss/build/grids-responsive.css'

import '~/src/lib/pure-toggle-menu'
import './index.css'
